import { render, staticRenderFns } from "./shaparak-info.vue?vue&type=template&id=f1aa2f7c"
import script from "./shaparak-info.vue?vue&type=script&lang=js"
export * from "./shaparak-info.vue?vue&type=script&lang=js"
import style0 from "./shaparak-info.vue?vue&type=style&index=0&id=f1aa2f7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports